import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { DialogService } from 'src/app/services/dialog.service';
import { EventiService } from 'src/app/services/eventi.service';
import { TemplateDataSource } from 'src/app/services/template.datasource';
import { TemplateService } from 'src/app/services/template.service';

@Component({
  selector: 'app-importa-template',
  templateUrl: './importa-template.component.html',
  styleUrls: ['./importa-template.component.css']
})
export class ImportaTemplateComponent implements OnInit {

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  arrowFlag: boolean = false;
  form: FormGroup;
  evento: String;
  dataSource: TemplateDataSource;
  idEvento: number = this.router.snapshot.params.id;
  risultatiPerPagina: number = 10;
  displayedColumns: string[] = ['idTemplate', 'descrizione', 'tpModulo', 'descrtpModulo', 'flDistribuito', 'actions'];
  confirmed: string;

  templatesSearchableDto: ModelEventiCalamitosi.TemplateImportSearchableDto = {
    idEvento: null,
    tpModulo: null,
    idTemplate: null,
    descrizioneEvento: null,
    descrizioneTemplate: null
  };
  public searchFilters: ModelEventiCalamitosi.TemplateImportSearchableDto;

  constructor(
    private route: Router,
    private router: ActivatedRoute,
    private eventoSvc: EventiService,
    private templateService: TemplateService,
    private lsEventiDialogSvc: DialogService,
    private alertsCenterService: AlertsCenterService
  ) { }

  ngOnInit(): void {
    this.buildForm();

    this.dataSource = new TemplateDataSource(this.templateService);
    this.dataSource.errors$.subscribe(res => {
      if(res) this.alertsCenterService.showAlert({
        message: `Errore lettura dati`,
        type: 'danger',
        autoClosable: false
      });
    })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.eventoSvc.getEvento(this.idEvento).subscribe(res => {
        this.evento = res.denominazione;
      })
        this.templatesSearchableDto.idEvento = this.idEvento;
      this.dataSource.loadTemplatesForImport('', this.templatesSearchableDto, 'idTemplate,ASC', 0, this.risultatiPerPagina);
      this.form.valueChanges.subscribe(() => this.paginator.pageIndex = 0);
      // reset the paginator after sorting
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

      merge(this.sort.sortChange, this.paginator.page)
        .pipe(
          tap(() => {
            this.ricercaListaTemplate();
          }))
        .subscribe();

      this.dataSource.counter$
        .pipe(
          tap((count) => {
            this.paginator.length = count;
          })
        )
        .subscribe();
    });
  }


  private buildForm(): void {
    let group = {
      descrEvento: new FormControl(null, null),
      descrizioneTempl: new FormControl(null, null),
      tpModulo: new FormControl(null, null)
    }
    this.form = new FormGroup(group);
  }

  onNavigate() {
    this.route.navigate(["modifica-evento/" + this.router.snapshot.params.id + "/template-list"], { state: { denominazione: this.evento } });
  }

  public ricercaListaTemplate(resetPage?: boolean): void {

    this.searchFilters = {
      idEvento: this.templatesSearchableDto.idEvento,
      idTemplate: null,
      tpModulo: this.form.controls['tpModulo'].value !== "" ? this.form.controls['tpModulo'].value : null,
      descrizioneEvento: this.form.controls['descrEvento'].value !== "" ? this.form.controls['descrEvento'].value : null,
      descrizioneTemplate: this.form.controls['descrizioneTempl'].value !== "" ? this.form.controls['descrizioneTempl'].value : null,
    }
    this.dataSource.loadTemplatesForImport('', this.searchFilters, this.sort.active + "," + this.sort.direction, this.paginator.pageIndex, this.paginator.pageSize);
  }

  openImportConfirmDialog(idTemplate: number) {
    let title = 'Importa template';
    let message = 'Conferma import template '
    this.lsEventiDialogSvc.openDialog(title, message, '400px').subscribe(
      result => {
        this.confirmed = `${result}`;
        if (this.confirmed == "true") {

          this.importTemplate(idTemplate);
        }
      }
    );
  }

  importTemplate(idTemplate: number) {
    this.templateService.importaTemplate(idTemplate, this.idEvento).subscribe(res => {
      this.alertsCenterService.showAlert({
        message: `Importazione template avvenuta con successo`,
        type: 'success',
        autoClosable: false
      });
      this.dataSource.loadTemplatesForImport('', this.templatesSearchableDto, 'idTemplate,ASC', 0, this.risultatiPerPagina);
    },
      err => {
        this.alertsCenterService.showAlert({
          message: err.error.esitoServizio.descrizioneEsito,
          type: 'danger',
          autoClosable: false
        });
      })
  }

  onReset() {
    this.templatesSearchableDto = {
      idEvento: this.idEvento,
      tpModulo: null,
      idTemplate: null,
      descrizioneEvento: null,
      descrizioneTemplate: null
    };
    this.form.reset();
    this.dataSource.loadTemplatesForImport('', this.templatesSearchableDto, 'idTemplate,ASC', 0, this.risultatiPerPagina);
  }
}
